module.exports = __webpack_public_path__ + "static/media/4ODA11.077c2511.jpg";